import React from 'react';
import { blindBuriedHole } from 'pu-data/SelectOptions';
import { blindBuriedHole as tooltip } from 'pu-data/Tooltips';
import SelectComponent from './SelectComponent';

const BlindBuriedHole = (props) => {
  const name = 'blind_buried_hole';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label="Blind and Buried Hole"
      required={props.required}
      name={name}
      onChange={onChange}
      options={props.options}
      tooltip={props.tooltip}
      selected={props.parameters[name]}
      groupName={props.groupName} />
  );
};

BlindBuriedHole.defaultProps = {
  options: blindBuriedHole,
  tooltip,
};

export default BlindBuriedHole;
